import { Outlet, createFileRoute } from '@tanstack/react-router'
import type { ReactElement } from 'react'

import { SubscriptionsMobileNav } from '~/features/subscriptions/components/SubscriptionsMobileNav'

/**
 * `/admin/subscriptions` — pathless layout for every Subscriptions
 * sub-surface. Page-level navigation is owned by the canonical AdminShell
 * detail panel so the route content can match the handoff surfaces directly.
 *
 * Permission gating is layered: the `/admin` parent checks auth, and
 * the rail-config marks this branch as `subscription_management` so
 * the rail icon hides for non-permitted users. Direct URL access still
 * lands here — when the API returns 403 we let the sub-route render the
 * permission-denied empty state inline so the chrome stays consistent.
 */
export const Route = createFileRoute('/admin/subscriptions')({
  component: SubscriptionsLayout,
})

function SubscriptionsLayout(): ReactElement {
  return (
    <div className="ka-subscriptions-layout">
      <SubscriptionsMobileNav />
      <Outlet />
    </div>
  )
}
